import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Location, DatePipe } from "@angular/common";
import { SvgHeightDirective, SvgScaleDirective } from "./svg-group.directive";
import { SvgWidthDirective } from "./svg-group.directive";
import { GridsterModule } from "angular-gridster2";
import { ToastModule, ModalModule } from "ng-uikit-pro-standard";
import { SelectModule } from "ng-uikit-pro-standard";
import { IconsModule } from "ng-uikit-pro-standard";
import { NavbarModule } from "ng-uikit-pro-standard";
import { CheckboxModule } from "ng-uikit-pro-standard";
import { CardsModule } from "ng-uikit-pro-standard";
import { ButtonsModule } from "ng-uikit-pro-standard";
import { MDBBootstrapModulesPro } from "ng-uikit-pro-standard";
import { MDBSpinningPreloader } from "ng-uikit-pro-standard";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CommonModule } from "@angular/common";
import { NgxPageScrollCoreModule } from "ngx-page-scroll-core";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { DragDropModule } from "@angular/cdk/drag-drop";
// import { MatStepperModule } from "@angular/material";
// import { TableModule } from "primeng/table";

import {
  MatProgressBarModule,
  MatTooltipModule,
  MatToolbarModule,
  MatIconModule,
  MatCardModule,
  MatTableModule,
  MatInputModule,
  MatPaginatorModule,
  MatSortModule,
  MatSelectModule,
  MatDialogModule,
  MatDatepickerModule,
  MatRadioModule,
  MatButtonToggleModule,
  MatNativeDateModule,
  MatCheckboxModule,
  MatGridListModule,
  MatListModule,
  MatTabsModule,
  MatDividerModule,
  MatMenuModule,
  MatFormFieldModule,
  MatDialog,
  MAT_DIALOG_DATA,
  MatSliderModule,
  MatStepperModule,
  MatChipsModule,
  MatSlideToggleModule,
} from "@angular/material";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { HomeComponent } from "./home/home.component";
import { ToolbarComponent } from "./toolbar/toolbar.component";
import { ApplicationListComponent } from "./application/applicationlist/applicationlist.component";

import { AppConfig } from "./config";
import { MockupInput } from "./mockup-input";

import { ApplicationNewComponent } from "./application/applicationnew/applicationnew.component";
import { FooterComponent } from "./footer/footer.component";
import { ApplicationViewComponent } from "./application/applicationview/applicationview.component";
import { LabelTitlePipe } from "./label.pipe";
import { MetaobjectListComponent } from "./metaobject/metaobjectlist/metaobjectlist.component";
import { MetaobjectNewComponent } from "./metaobject/metaobjectnew/metaobjectnew.component";
import { MetaobjectViewComponent } from "./metaobject/metaobjectview/metaobjectview.component";
import { MetafieldViewComponent } from "./metafield/metafieldview/metafieldview.component";
import { MetafieldNewComponent } from "./metafield/metafieldnew/metafieldnew.component";
import { RecordTypeListComponent } from "./metaobject/recordtypelist/recordtypelist.component";
import { RecordTypeViewComponent } from "./metaobject/recordtypeview/recordtypeview.component";
import { RecordTypeNewComponent } from "./metaobject/recordtypenew/recordtypenew.component";
import { MetafieldListComponent } from "./metafield/metafieldlist/metafieldlist.component";
import { MetabuttonListComponent } from "./metabutton/metabuttonlist/metabuttonlist.component";
import { MetabuttonNewComponent } from "./metabutton/metabuttonnew/metabuttonnew.component";
import { MetabuttonViewComponent } from "./metabutton/metabuttonview/metabuttonview.component";
import { MetaLayoutNewComponent } from "./metalayout/metalayoutnew/metalayoutnew.component";
import { CustomViewNewComponent } from "./customview/customviewnew/customviewnew.component";
import { CustomViewListComponent } from "./customview/customviewlist/customviewlist.component";
import { MetaLayoutListComponent } from "./metalayout/metalayoutlist/metalayoutlist.component";
import { ModalComponent } from "./modalcomponent/modalcomponent.component";
import { PageComponent } from "./page/page.component";
import { FieldComponent } from "./page/field/field.component";
import { FieldLayoutComponent } from "./page/field-layout/field-layout.component";
import { DialogComponent } from "./page/dialog/dialog.component";
import { BlankSpaceComponent } from "./page/blank-space/blank-space.component";
import { SectionComponent } from "./page/section/section.component";
import { EmptySectionComponent } from "./page/empty-section/empty-section.component";
import { PropertiesDialogComponent } from "./page/field-layout/properties-dialog/properties-dialog.component";
import { SectionDialogComponent } from "./page/section-dialog/section-dialog.component";
import { MetaLayoutViewComponent } from "./metalayout/metalayoutview/metalayoutview.component";
import { MetaLayoutQuickComponent } from "./metalayout/metalayoutquick/metalayoutquick.component";
import { MetaLayoutSelectorComponent } from "./metalayout/metalayoutselector/metalayoutselector.component";
import { ButtonLayoutComponent } from "./page/button-layout/button-layout.component";
import { ButtonDropComponent } from "./page/button-drop/button-drop.component";
import { GroupattributesDialogComponent } from "./page/groupattributes-dialog/groupattributes-dialog.component";
import { GlobalactionComponent } from "./globalaction/globalaction.component";
import { NewactionComponent } from "./globalaction/newaction/newaction.component";
import { GlobalactionLayoutComponent } from "./globalaction/globalaction-layout/globalaction-layout.component";
import { GlobalactionFieldComponent } from "./globalaction/globalaction-field/globalaction-field.component";
import { GlobalactionSectionComponent } from "./globalaction/globalaction-section/globalaction-section.component";
import { GlobalactionSectiondialogComponent } from "./globalaction/globalaction-sectiondialog/globalaction-sectiondialog.component";
import { GlobalactionFielddialogComponent } from "./globalaction/globalaction-fielddialog/globalaction-fielddialog.component";
import { SearchlayoutComponent } from "./searchlayout/searchlayout/searchlayout.component";
import { SearchprofilelayoutComponent } from "./searchlayout/searchprofilelayout/searchprofilelayout.component";
import { SearchlayoutfieldsComponent } from "./searchlayout/searchlayoutfields/searchlayoutfields.component";
import { MetarelatedlistComponent } from "./page/metarelatedlist/metarelatedlist.component";
import { MetarelatedlistdropComponent } from "./page/metarelatedlistdrop/metarelatedlistdrop.component";
import { MetarelatedlistfieldComponent } from "./page/metarelatedlistfield/metarelatedlistfield.component";
import { ProcessesComponent } from "./processes/processes.component";
import { NewprocessComponent } from "./processes/newprocess/newprocess.component";
import { ProcessfieldComponent } from "./processes/processfield/processfield.component";
import { RecordtypelayoutComponent } from "./metaobject/recordtypelayout/recordtypelayout.component";
import { RecordtypeComponent } from "./recordtype/recordtype.component";
import { SharedDataService } from "./shared-data.service";
import { LayoutassignmentComponent } from "./metaobject/layoutassignment/layoutassignment.component";
import { MetafieldhistoryComponent } from "./metafield/metafieldhistory/metafieldhistory.component";
import { ReporttypesComponent } from "./reporttypes/reporttypes.component";
import { NewreporttypeComponent } from "./reporttypes/newreporttype/newreporttype.component";
import { ReportsComponent } from "./reports/reports.component";
import { FolderComponent } from "./folder/folder.component";
import { NewfolderComponent } from "./folder/newfolder/newfolder.component";
import { DynamicComponentLoaderDirective } from "./dynamic-component-loader.directive";
import { SubfolderComponent } from "./folder/subfolder/subfolder.component";
import { RefinedlayoutnewComponent } from "./refinedlayout/refinedlayoutnew/refinedlayoutnew.component";
import { RefinedlayoutlistComponent } from "./refinedlayout/refinedlayoutlist/refinedlayoutlist.component";
import { ReporttypelayoutComponent } from "./reporttypes/reporttypelayout/reporttypelayout.component";
import { AllReportsComponent } from "./reports/all-reports/all-reports.component";
import { NewreportComponent } from "./reports/newreport/newreport.component";
import { NewconvertsettingComponent } from "./convertsetting/newconvertsetting/newconvertsetting.component";
import { ConvertsettinglistComponent } from "./convertsetting/convertsettinglist/convertsettinglist.component";
import { ConvertmappingfieldComponent } from "./convertsetting/convertmappingfield/convertmappingfield.component";
import { DashboardComponent } from "./dashboard/dashboard/dashboard.component";
import { WidgetComponent } from "./dashboard/widget/widget.component";
import { BarChartComponent } from "./dashboard/bar-chart/bar-chart.component";
import { ParentContainerComponent } from "./dashboard/parent-container/parent-container.component";
import { XAxisComponent } from "./dashboard/x-axis/x-axis.component";
import { TestDashboardComponent } from "./dashboard/test-dashboard/test-dashboard.component";
import { Example1Component } from "./dashboard/example1/example1.component";
import { Example2Component } from "./dashboard/example2/example2.component";
import { DashboardItemDirective } from "./directives/dashboard-item.directive";
import { DashboardlistComponent } from "./dashboard/dashboardlist/dashboardlist.component";
import { WizardlayoutlistComponent } from "./wizardlayout/wizardlayoutlist/wizardlayoutlist.component";
import { WizardlayoutnewComponent } from "./wizardlayout/wizardlayoutnew/wizardlayoutnew.component";
import { GrouptranslationDialogComponent } from "./page/grouptranslation-dialog/grouptranslation-dialog.component";
import { ValidationrulelistComponent } from "./validationrule/validationrulelist/validationrulelist.component";
import { ValidationrulenewComponent } from "./validationrule/validationrulenew/validationrulenew.component";
import { MatchingrulelistComponent } from "./matchingrule/matchingrulelist/matchingrulelist.component";
import { MatchingrulenewComponent } from "./matchingrule/matchingrulenew/matchingrulenew.component";
import { ObjectselectComponent } from "./matchingrule/objectselect/objectselect.component";
import { DuplicaterulelistComponent } from "./duplicaterule/duplicaterulelist/duplicaterulelist.component";
import { DuplicaterulenewComponent } from "./duplicaterule/duplicaterulenew/duplicaterulenew.component";
import { AuthInterceptor } from "./auth.interceptor";
import { CrudmessagenewComponent } from "./crudmessage/crudmessagenew/crudmessagenew.component";
import { CrudmessagelistComponent } from "./crudmessage/crudmessagelist/crudmessagelist.component";
import { ErrormessagenewComponent } from "./errormessage/errormessagenew/errormessagenew.component";
import { ErrormessagelistComponent } from "./errormessage/errormessagelist/errormessagelist.component";
import { SectionrootnewComponent } from "./modulesettings/sectionrootnew/sectionrootnew.component";
import { SectionrootlistComponent } from "./modulesettings/sectionrootlist/sectionrootlist.component";
import { ModulesettinglistComponent } from "./modulesettings/modulesettinglist/modulesettinglist.component";
import { ModulesettingnewComponent } from "./modulesettings/modulesettingnew/modulesettingnew.component";
import { MetafielddependencieslistComponent } from "./metafield/metafielddependencies/metafielddependencieslist/metafielddependencieslist.component";
import { MetafielddependenciesnewComponent } from "./metafield/metafielddependencies/metafielddependenciesnew/metafielddependenciesnew.component";
import { RecordtypepicklistComponent } from "./metaobject/recordtypepicklist/recordtypepicklist.component";
import { DomainSettingslistComponent } from "./domainsettings/domainsettingslist/domain-settings.component";
import { DomainConfinewComponent } from "./domainsettings/domainsettingsnew/domain-confinew.component";
import { DomainConfigSectionComponent } from "./domainsettings/domainsettingssection/domain-config-section.component";
import { DomainsettingsconfigkeyComponent } from "./domainsettings/domainsettingsfields/domainsettingsconfigkey.component";
import { domainsectionectionnewComponent } from "./domainsettings/domainsettingsectionlist/domainsettingsectionnew.component";
import { DomainfieldslistComponent } from "./domainsettings/domainfieldslist/domainfieldslist.component";
// import { ErrorcodeComponent } from './errorcode/errorcode.component';
import { ErrorcodelistComponent } from "./errorcode/errorcodelist/errorcodelist.component";
import { ErrorcodenewComponent } from "./errorcode/errorcodenew/errorcodenew.component";
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    ToolbarComponent,
    ApplicationListComponent,
    ApplicationNewComponent,
    FooterComponent,
    ApplicationViewComponent,
    LabelTitlePipe,
    MetaobjectListComponent,
    MetaobjectNewComponent,
    MetaobjectViewComponent,
    MetafieldViewComponent,
    MetafieldNewComponent,
    RecordTypeListComponent,
    RecordTypeViewComponent,
    RecordTypeNewComponent,
    MetafieldListComponent,
    MetabuttonListComponent,
    MetabuttonNewComponent,
    MetabuttonViewComponent,
    MetaLayoutNewComponent,
    CustomViewNewComponent,
    CustomViewListComponent,
    MetaLayoutListComponent,
    MetaLayoutViewComponent,
    MetaLayoutQuickComponent,
    MetaLayoutSelectorComponent,
    ModalComponent,
    PageComponent,
    FieldComponent,
    FieldLayoutComponent,
    DialogComponent,
    BlankSpaceComponent,
    SectionComponent,
    EmptySectionComponent,
    PropertiesDialogComponent,
    SectionDialogComponent,
    ButtonLayoutComponent,
    ButtonDropComponent,
    GroupattributesDialogComponent,
    GlobalactionComponent,
    NewactionComponent,
    GlobalactionLayoutComponent,
    GlobalactionFieldComponent,
    GlobalactionSectionComponent,
    GlobalactionSectiondialogComponent,
    GlobalactionFielddialogComponent,
    SearchlayoutComponent,
    SearchprofilelayoutComponent,
    SearchlayoutfieldsComponent,
    MetarelatedlistComponent,
    MetarelatedlistdropComponent,
    MetarelatedlistfieldComponent,
    ProcessesComponent,
    NewprocessComponent,
    ProcessfieldComponent,
    RecordtypelayoutComponent,
    RecordtypeComponent,
    RecordTypeNewComponent,
    LayoutassignmentComponent,
    MetafieldhistoryComponent,
    ReporttypesComponent,
    NewreporttypeComponent,
    ReportsComponent,
    FolderComponent,
    NewfolderComponent,
    DynamicComponentLoaderDirective,
    SubfolderComponent,
    RefinedlayoutnewComponent,
    RefinedlayoutlistComponent,
    ReporttypelayoutComponent,
    AllReportsComponent,
    NewreportComponent,
    NewconvertsettingComponent,
    ConvertsettinglistComponent,
    ConvertmappingfieldComponent,
    DashboardComponent,
    WidgetComponent,
    BarChartComponent,
    ParentContainerComponent,
    XAxisComponent,
    SvgHeightDirective,
    SvgScaleDirective,
    SvgWidthDirective,
    TestDashboardComponent,
    Example1Component,
    Example2Component,
    DashboardItemDirective,
    DashboardlistComponent,
    WizardlayoutlistComponent,
    WizardlayoutnewComponent,
    GrouptranslationDialogComponent,
    ValidationrulelistComponent,
    ValidationrulenewComponent,
    MatchingrulelistComponent,
    MatchingrulenewComponent,
    ObjectselectComponent,
    DuplicaterulelistComponent,
    DuplicaterulenewComponent,
    CrudmessagenewComponent,
    CrudmessagelistComponent,
    ErrormessagenewComponent,
    ErrormessagelistComponent,
    SectionrootnewComponent,
    SectionrootlistComponent,
    ModulesettinglistComponent,
    ModulesettingnewComponent,
    MetafielddependencieslistComponent,
    MetafielddependenciesnewComponent,
    RecordtypepicklistComponent,
    DomainSettingslistComponent,
    DomainConfinewComponent,
    DomainConfigSectionComponent,
    DomainsettingsconfigkeyComponent,
    domainsectionectionnewComponent,
    DomainfieldslistComponent,
    // ErrorcodeComponent,
    ErrorcodelistComponent,
    ErrorcodenewComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatProgressBarModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatFormFieldModule,
    MatCardModule,
    MatSidenavModule,
    MatTabsModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatGridListModule,
    MatListModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatChipsModule,
    MatSidenavModule,
    MatExpansionModule,
    MatButtonModule,
    SelectModule,
    NgxPageScrollCoreModule,
    TypeaheadModule.forRoot(),
    DragDropModule,
    MatDividerModule,
    IconsModule,
    NavbarModule,
    CheckboxModule,
    CardsModule,
    ButtonsModule,
    MatFormFieldModule,
    MatSliderModule,
    MatSlideToggleModule,
    GridsterModule,
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    // TableModule,
    ToastModule.forRoot(),
    ModalModule.forRoot(),
  ],
  entryComponents: [
    ModalComponent,
    DialogComponent,
    BlankSpaceComponent,
    PropertiesDialogComponent,
    SectionDialogComponent,
    GroupattributesDialogComponent,
    GlobalactionSectiondialogComponent,
    GlobalactionFielddialogComponent,
    MetarelatedlistfieldComponent,
    NewfolderComponent,
    FolderComponent,
    ParentContainerComponent,
    Example1Component,
    Example2Component,
    TestDashboardComponent,
    GrouptranslationDialogComponent,
  ],
  providers: [
    AppConfig,
    MockupInput,
    RecordTypeListComponent,
    SharedDataService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true, // Allows multiple interceptors to be added
    },
  ],
  schemas: [NO_ERRORS_SCHEMA],

  bootstrap: [AppComponent],
})
export class AppModule {}
